import { ReactElement } from 'react';
import './style.scss';
import { Caption } from 'views/mutual/caption';
import { RequestHistoryHeader } from './module/historyHeader';
import { useRequestHistoryListPage } from './hooks';
import { RequestHistoryList } from './module/historyList';
import { LoadingContainer } from 'views/mutual/loading';
import { Pagination } from 'views/mutual/pagination';
import { ComponentControl } from 'views/mutual/componentControl';

export const RequestHistory = () => {
  const { applicationList, currentPage, setCurrentPage, perPageCount } = useRequestHistoryListPage();

  return (
    <>
      <div className="requestHistory">
        <Caption label="申込履歴一覧" />
        <div className="requestHistory_wrapper">
          <RequestHistoryHeader />
          <LoadingContainer isLoading={applicationList.fetching}>
            <ComponentControl
              isLoading={applicationList.fetching}
              items={applicationList.data?.GetApplicationList?.Data || []}
              noDataMessege="申込履歴はありません"
              componentName={RequestHistoryList}
            />
          </LoadingContainer>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            fetchApi={() => {}}
            totalCount={applicationList.data?.GetApplicationList?.TotalCount || 0}
            perPageCount={perPageCount}
          />
        </div>
      </div>
    </>
  );
};
